import { createContext } from 'react';

export const EventPackageContext = createContext();
export const SECTIONS = ['general', 'mkt tix', 'tkt $ hist', 'sug $ hist', 'raw'];
